import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)

export const navigationBlocks = () => {

	let els = document.querySelectorAll('[animation="navigation-blocks"]')

	if (!els.length || window.innerWidth <= 720) return

	els.forEach(el => {

		let items = el.querySelectorAll('[data-el="item"]'),
			end = '+=' + window.innerHeight * 3

		let tl = gsap.timeline({
			scrollTrigger: {
				trigger: el,
				start: 'center center',
				end: end,
				scrub: true,
				pin: true,
				// markers: true,
			}
		})

		items.forEach((item, index) => {
			let bar = item.querySelector('.loading-bar')

			let itemtl = gsap.timeline({
				onStart: () => {
					items.forEach(i => i.removeAttribute('data-status'))
					item.setAttribute('data-status', 'active')
				},
				onReverseComplete: () => {
					item.removeAttribute('data-status')
					if (index > 0) {
						items[index - 1].setAttribute('data-status', 'active')
					}
				}
			})

			itemtl.fromTo(bar,
				{ width: '0%' },
				{ width: '100%', duration: 1, ease: 'none' }
			)

			tl.add(itemtl)
		})
	})
}

export default () => { }